import {_post} from "@api/services/httpService";

const URL = '/nextore/accounts'

export const postNextoreAccount = (data) => _post(URL, data);
